import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './component/login/login.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { RolesComponent } from './component/settings/roles/roles.component';
import { UsersComponent } from './component/settings/users/users.component';
import { UnionLocalsComponent } from './component/settings/union-locals/union-locals.component';
import { DesignComponent } from './component/settings/design/design.component';
import { SmtpConfigurationComponent } from './component/settings/smtp-configuration/smtp-configuration.component';
import { ToolSettingsComponent } from './component/settings/tool-settings/tool-settings.component';
import { JobsComponent } from './component/jobs/jobs.component';
import { OwnerInfoComponent } from './component/jobs/owner-info/owner-info.component';
import { AddEditOwnerInfoComponent } from './component/jobs/owner-info/add-edit-owner-info/add-edit-owner-info.component';
import { JobDetailsComponent } from './component/jobs/job-details/job-details.component';
import { JobStatusComponent } from './component/jobs/job-status/job-status.component';
import { InvoicesComponent } from './component/jobs/invoices/invoices.component';
import { ResetPasswordComponent } from './component/login/reset-password/reset-password.component';
import { CustomersComponent } from './component/jobs/customers/customers/customers.component';
import { EditCustomerComponent } from './component/jobs/customers/edit-customer/edit-customer/edit-customer.component';
import { ToolModelListComponent } from './component/tools/tool-model-list/tool-model-list.component';
import { ToolTransferListComponent } from './component/tools/tool-transfer-list/tool-transfer-list.component';
import { ToolPageComponent } from './component/tools/tool-page/tool-page.component';
import { ToolListPageComponent } from './component/tools/tool-list-page/tool-list-page.component';
import { ToolModelPageComponent } from './component/tools/tool-model-page/tool-model-page.component';
import { JobBoardComponent } from './component/job-pointe/job-board/job-board.component';
import { ManageJobsComponent } from './component/job-pointe/manage-jobs/manage-jobs.component';
import { EmployeesComponent } from './component/job-pointe/employees/employees.component';
import { ConfigurationComponent } from './component/job-pointe/configuration/configuration.component';
import { ToolInventoryComponent } from './component/tools/tool-inventory/tool-inventory.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  {
    path: 'jobs',
    children: [
      { path: '', component: JobsComponent },
      { path: 'status', component: JobStatusComponent },
      { path: 'invoices', component: InvoicesComponent },
      { path: ':id', component: JobDetailsComponent },
    ],
  },
  { path: 'customers', component: CustomersComponent },
  { path: 'customers/edit_customers', component: EditCustomerComponent },
  { path: 'owner_info', component: OwnerInfoComponent },
  { path: 'owner_info/add_edit', component: AddEditOwnerInfoComponent },
  {
    path: 'settings',
    children: [
      { path: 'roles', component: RolesComponent },
      { path: 'system_users', component: UsersComponent },
      { path: 'union_locals', component: UnionLocalsComponent },
      { path: 'design', component: DesignComponent },
      { path: 'smtp', component: SmtpConfigurationComponent },
      {
        path: 'tools',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'asset-classes' },
          { path: 'asset-classes', component: ToolSettingsComponent },
          { path: 'manufacturers', component: ToolSettingsComponent },
          { path: 'categories', component: ToolSettingsComponent },
          { path: 'shop-locations', component: ToolSettingsComponent },
        ],
      },
    ],
  },
  {
    path: 'tools',
    children: [
      { path: '', component: ToolListPageComponent },
      { path: 'add/:id', component: ToolPageComponent },
      { path: 'edit/:id', component: ToolPageComponent },
      {
        path: 'models',
        children: [
          { path: '', component: ToolModelListComponent },
          { path: 'add/:id', component: ToolModelPageComponent },
          { path: 'edit/:id', component: ToolModelPageComponent },
        ],
      },
      {
        path: 'transfers',
        children: [{ path: '', component: ToolTransferListComponent }],
      },
      {
        path: 'inventory',
        children: [
          { path: '', component: ToolInventoryComponent },
        ],
      }
    ],
  },
  {
    path: 'job-pointe',
    children: [
      { path: '', component: JobBoardComponent },
      {
        path: 'job-board',
        children: [{ path: '', component: JobBoardComponent }],
      },
      {
        path: 'manage-jobs',
        children: [{ path: '', component: ManageJobsComponent }],
      },
      {
        path: 'employees',
        children: [{ path: '', component: EmployeesComponent }],
      },
      {
        path: 'configuration',
        children: [
          { path: '', component: ConfigurationComponent },
          { path: 'attributes', component: ConfigurationComponent },
          { path: 'employee-types', component: ConfigurationComponent },
          // attributes
        ],
      },
    ],
  },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: '', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
